import { FC } from "react";

import { IgLoading } from "@intelligems/ig-theme/IgLoading";
import { IgTypography } from "@intelligems/ig-theme/IgTypography";
import { Stack } from "@mui/material";

export interface LoadingProps {
  centered?: boolean;
  message?: string;
}

const Loading: FC<LoadingProps> = ({ centered, message }) => {
  return (
    <Stack
      className={centered ? "ig-loading-centered" : undefined}
      sx={{
        alignItems: "center",
        gap: 4,
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      }}
    >
      <IgLoading />
      {message && <IgTypography>{message}</IgTypography>}
    </Stack>
  );
};

export default Loading;
